export default __webpack_public_path__ + "fb69c4aaafd51c69476df231d9893509.png";